import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, InjectionToken, PLATFORM_ID } from '@angular/core';

export const BROWSER_COOKIE = new InjectionToken<Document>('Browser Cookie', {
  providedIn: 'root',
  factory: () => (typeof document !== 'undefined' ? document : null)
});

@Injectable({
  providedIn: 'root'
})
export class BrowserCookieService {

  private domain: string;

  constructor(
    @Inject(PLATFORM_ID) private _platformBrowserId: Object,
    @Inject(BROWSER_COOKIE) private document: Document
  ) {
    this.getDomain();
  }


  getDomain(): void {
    if (isPlatformBrowser(this._platformBrowserId)) {
      const isLocalHost = document.location.origin.includes("localhost");
      this.domain = isLocalHost ? "localhost" : ".segofinance.com";

      // Asignacion dominios staticwebapps para entornos staging
      const isSegoStaticWebApp = document.location.origin.includes("gray-sky-0f2907703.5.azurestaticapps.net");
      const isPlatformStaticWebApp = document.location.origin.includes(".westeurope.5.azurestaticapps.net");

      if (isSegoStaticWebApp) {
        this.domain = ".gray-sky-0f2907703.5.azurestaticapps.net";
      } 
      else if (isPlatformStaticWebApp) {
        this.domain = ".westeurope.5.azurestaticapps.net";
      }
    }
  }

  get(key: string): string | null {
    const cookies = this.document.cookie.split(';');
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=');
      if (cookieName === key) {
        return cookieValue;
      }
    }
    return null;
  }

  set(key: string, value: string, expires?: Date) {
    let cookieString = `${key}=${value}`;
    const days: number = 4; // Valor por defecto si no viene el expires
    const expiresDate = expires ? new Date(expires) : new Date(Date.now() + 1000 * 60 * 60 * 24 * days).toUTCString();
    cookieString += `; expires=${expiresDate}`;
    if (this.domain) {
      cookieString += `; domain=${this.domain}`;
    }
    cookieString += '; Secure';
    this.document.cookie = cookieString;
  }

  remove(key: string) {
    let cookieString = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
    if (this.domain) {
      cookieString += `; domain=${this.domain}`;
    }

    cookieString += '; Secure';
    this.document.cookie = cookieString;
  }

  clear() {
    const cookies = this.document.cookie.split(';');
    for (const cookie of cookies) {
      const [cookieName,] = cookie.trim().split('=');
      this.remove(cookieName);
    }
  }
}